<script setup lang="ts">
import { getProductName } from "@shopware/helpers";

const props = defineProps<{
  navigationId: string;
}>();

const { search } = useProductSearch();
const { clearBreadcrumbs, buildDynamicBreadcrumbs, pushBreadcrumb } = useBreadcrumbs();
const { apiClient } = useShopwareContext();

const { data, error } = await useAsyncData(
  `cmsProduct${props.navigationId}`,
  async () => {
    const responses = await Promise.allSettled([
      search(props.navigationId, {
        withCmsAssociations: true,
        associations: {
          manufacturer: {
            associations: {
              media: {},
            },
          },
          crossSellings: {
            products: {},
          },
          properties: {
            associations: {
              group: {},
              media: {},
            },
          },
          options: {},
          seoUrls: {},
        },
      }),
      apiClient.invoke("readBreadcrumb get /breadcrumb/{id}", {
        pathParams: {
          id: props.navigationId,
        },
      }),
    ]);

    for (const response of responses) {
      if (response.status === "rejected") {
        console.error("[FrontendDetailPage.vue]", response.reason.message);
      }
    }

    return {
      productResponse:
        responses[0].status === "fulfilled" ? responses[0].value : null,
      breadcrumbs:
        responses[1].status === "fulfilled" ? responses[1].value : null,
    };
  }
);
const productResponse = ref(data.value?.productResponse);

clearBreadcrumbs();
const breadcrumbData = data.value?.breadcrumbs?.data;
if (Array.isArray(breadcrumbData) && breadcrumbData.length > 0) {
  const crumbs = breadcrumbData.map((bc: any) => ({
    name: bc.translated?.name || bc.name,
    path: bc.type !== "folder" && bc.seoUrls?.[0]?.seoPathInfo ? `/${bc.seoUrls[0].seoPathInfo}` : undefined,
  }));
  useBreadcrumbs(crumbs);
} else if (breadcrumbData?.breadcrumbs) {
  buildDynamicBreadcrumbs(breadcrumbData);
}

if (!productResponse.value) {
  console.error("[FrontendDetailPage.vue]", error.value?.message);
  throw error.value;
}

useProductJsonLD(productResponse.value.product);

pushBreadcrumb({
  name: getProductName({ product: productResponse.value.product }) ?? "",
  path: `/${productResponse.value.product.seoUrls?.[0]?.seoPathInfo}`,
});

const { product } = useProduct(
  productResponse.value.product,
  productResponse.value.configurator
);

const runtimeConfig = useRuntimeConfig();
const { locale } = useI18n();

useCmsHead(product, {
  mainShopTitle: runtimeConfig.public.general.shopTitle[locale.value],
});

provide("product-detail", true);
</script>

<template>
  <div class="detail-layout-wrapper">
    <div class="px-4 md:px-0">
      <LayoutBreadcrumbs/>
    </div>
    <div class="detail-page">
      <div class="bg-skin-body bg-opacity-70">
        
      </div>
      <div v-if="product?.cmsPage">
        <CmsPage :content="product.cmsPage" />
      </div>
    </div>
  </div>
</template>
